"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Result = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_loader_1 = require("@travelnest/merlin.loader");
const react_1 = __importDefault(require("react"));
const ResultSuccess_1 = require("./ResultSuccess");
const ResultFailure_1 = require("./ResultFailure");
const StyledLoader = styled_1.default.div `
	height: 60px
`;
const Result = ({ loading, success }) => loading ?
    react_1.default.createElement(StyledLoader, null,
        react_1.default.createElement(merlin_loader_1.Loader, null)) :
    success ? react_1.default.createElement(ResultSuccess_1.ResultSuccess, null) : react_1.default.createElement(ResultFailure_1.ResultFailure, null);
exports.Result = Result;
//# sourceMappingURL=Result.js.map